/* eslint-disable no-console */
import { DebugConfig } from './debugConfig';

export type DebugSection = keyof Omit<DebugConfig, 'dumpLogs'>;

export type Log = { section: DebugSection; name: string; args: unknown[] };

export type Subscription = (log: Log) => void;

const localStorageDumpKey = 'DEBUG_MODE_DUMP';

class _DebugLogger {
  private logs: Log[];
  private subscriptions: Subscription[];

  constructor() {
    this.subscriptions = [];

    try {
      const logsDump = localStorage.getItem(localStorageDumpKey);
      localStorage.removeItem(localStorageDumpKey);
      this.logs = logsDump ? (JSON.parse(logsDump) as Log[]) : [];
    } catch {
      this.logs = [];
    }
  }

  dumpLogs() {
    try {
      localStorage.setItem(localStorageDumpKey, JSON.stringify(this.getLogs()));
    } catch {
      /* empty */
    }
  }

  subscribe(subscription: Subscription) {
    this.subscriptions.push(subscription);

    return {
      unsubscribe: () => {
        this.subscriptions = this.subscriptions.filter(sb => sb !== subscription);
      },
    };
  }

  log(section: DebugSection, name: string, ...args: unknown[]) {
    const log = { section, name, args };
    this.logs.push(log);

    this.subscriptions.forEach(subscription => {
      subscription(log);
    });
  }

  getLogs() {
    return this.logs;
  }
}

export const DebugLogger = new _DebugLogger();
